"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeThumbnail = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRemainingLifeThumbnail = exports.ComponentRemainingLifeThumbnail = function ComponentRemainingLifeThumbnail(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "256",
    height: "256",
    fill: "currentColor",
    viewBox: "0 0 100 100",
    y: "0"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: "#F6928F"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: "48",
    y: "25",
    textAnchor: "middle",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: "40",
    fontWeight: "bold",
    alignmentBaseline: "middle",
    "data-testid": "UnitValue"
  }, "9"), " ", /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: "24",
    alignmentBaseline: "middle",
    "data-testid": "UnitsSymbol"
  }, "%")), /*#__PURE__*/_react["default"].createElement("text", {
    x: "50",
    y: "50",
    fontSize: "14",
    fill: "currentColor",
    textAnchor: "middle",
    alignmentBaseline: "hanging"
  }, "Remaining Life"));
};